/*
  Srovnávač LED 2 - ovládání stránky: vstupy, varianty, ceny, KALKULACE a e-mail.
  Výsledky (verdikt, tabulka, graf) počítá vysledky.js.
  Zákazník zadá svoje LED, po kliknutí na KALKULACE vidí úsporu na 1 m² s LEDBARem.
  Výpočet a e-mail se odesílají do Google Sheets (VYCHOZI.odeslani.url v obsah.js).
  Vše hledá jen uvnitř prvku koren - nic mimo srovnávač se nemění.
*/
import { VYCHOZI, HTML } from './obsah.js';
import { spocitejVysledky } from './vysledky.js';

export function spustSrovnavac(koren) {
koren.innerHTML = HTML;

let N = nacti();

function nacti(){ return structuredClone(VYCHOZI); }
const $ = id => koren.querySelector("#" + id);
const fmt = (x,d=0) => Number.isFinite(x) ? x.toLocaleString("cs-CZ",{minimumFractionDigits:d,maximumFractionDigits:d}) : "-";
const num = v => { const x = parseFloat(String(v ?? "").replace(/\s/g,"").replace(",", ".")); return Number.isFinite(x) ? x : NaN; };
const hodnota = v => (v === null || v === undefined) ? NaN : Number(v);

function vstup(id, popis, h, jednotka){
  return `<label for="${id}">${popis}<span class="vstup"><input id="${id}" inputmode="decimal" value="${String(h ?? "").replace(".", ",")}"><span>${jednotka}</span></span></label>`;
}
const vsechnyHloubky = () => [...new Set(N.produkty.flatMap(p => p.tabulka.map(t => t.hodnota)))].sort((a,b)=>a-b);
const radekTabulky = (p, h) => p.tabulka.find(t => String(t.hodnota) === String(h));

function postav(){
  $("nasePopisek").textContent = "Nabídka " + N.firma;
  $("paticka").textContent = N.paticka;

  const p = N.priklad || {};
  let h = `<label for="z_nazev" style="grid-column:1/-1">Název vašich LED<span class="vstup"><input id="z_nazev" type="text" placeholder="např. výrobce a typ modulu" value="${(p.nazev||"").replace(/"/g,"&quot;")}"></span></label>`;
  if(N.kryti) h += `<label for="z_kryti" style="grid-column:1/-1">Použití vašich LED<span class="vstup"><select id="z_kryti"><option value="">Nevím</option>${N.kryti.map(k => `<option value="${k.hodnota}" ${k.hodnota===p.kryti?"selected":""}>${k.nazev}</option>`).join("")}</select></span></label>`;
  h += vstup("z_ks", `Počet kusů na 1 ${N.jednotkaPlochy}`, p.ks, `${N.kus}/${N.jednotkaPlochy}`);
  N.parametry.forEach(par => { h += vstup("z_"+par.klic, `${par.nazev} za 1 ${N.kus}`, p[par.klic], par.jednotka); });
  (N.vlastnosti||[]).forEach(v => { h += vstup("z_"+v.klic, v.nazev, p[v.klic], v.jednotka); });
  $("poleZakaznik").innerHTML = h;

  const v = N.volba;
  $("poleVarianta").innerHTML =
    `<label for="v_hloubka">${v.nazev}<span class="vstup"><select id="v_hloubka">${
      vsechnyHloubky().map(x => `<option value="${x}" ${x==v.vychozi?"selected":""}>${fmt(x)} ${v.jednotka}</option>`).join("")
    }</select></span></label>
    <label for="v_produkt">Varianta ${N.rada || ""}<span class="vstup"><select id="v_produkt"></select></span></label>
    <label for="v_ks">Kusů na 1 ${N.jednotkaPlochy}<span class="vstup"><input id="v_ks" inputmode="decimal"><span>${N.kus}/${N.jednotkaPlochy}</span></span></label>
    <div class="ks-pozn maly" id="ksPozn"></div>
    ${N.baleni ? `<label for="v_cena" style="grid-column:1/-1">Cena podle nákupu<span class="vstup"><select id="v_cena"></select></span></label>` : ""}`;
  naplnProdukty(N.vychoziProdukt);

  const ramy = N.ramy || { sirka: 1000, vyska: 1000, pocet: 1 };
  $("poleProjekt").innerHTML =
    `<label for="r_sirka">Šířka rámu<span class="vstup"><input id="r_sirka" inputmode="decimal" value="${String(ramy.sirka ?? "").replace(".", ",")}"><span>mm</span></span></label>
    <label for="r_vyska">Výška rámu<span class="vstup"><input id="r_vyska" inputmode="decimal" value="${String(ramy.vyska ?? "").replace(".", ",")}"><span>mm</span></span></label>
    <label for="r_pocet">Počet rámů<span class="vstup"><input id="r_pocet" type="number" min="1" step="1" inputmode="numeric" value="${ramy.pocet ?? 1}"><span>ks</span></span></label>
    <div class="rozmer-plocha" id="ramPlocha"></div>`;

  koren.querySelectorAll(".vstupy input, #poleProjekt input, #v_cena").forEach(el => el.addEventListener("input", e => {
    if(e.target.id.startsWith("z_")) $("priklad").hidden = true;
    oznacZmenu();
    aktualizuj();
  }));
  $("v_hloubka").addEventListener("input", () => { naplnProdukty($("v_produkt").value); ksDleSpec(); aktualizuj(); });
  $("v_produkt").addEventListener("input", () => { naplnCeny(true); ksDleSpec(); aktualizuj(); });
  $("z_kryti")?.addEventListener("input", e => {
    $("priklad").hidden = true;
    const k = e.target.value; if(!k) return aktualizuj();
    const h = $("v_hloubka").value;
    const kandidati = [...N.produkty].sort((a,b) => (b.id === N.vychoziProdukt) - (a.id === N.vychoziProdukt));
    let cil = kandidati.find(p => p.kryti === k && radekTabulky(p, h));
    if(!cil){ cil = N.produkty.find(p => p.kryti === k); if(cil){ $("v_hloubka").value = cil.tabulka[0].hodnota; } }
    if(cil){ naplnProdukty(cil.id); naplnCeny(true); ksDleSpec(); }
    aktualizuj();
  });
  naplnCeny(true);
  ksDleSpec();
  spocitej();
}
/* počet kusů na m² - výchozí ze specifikace, zákazník ho může přepsat */
const specRadek = () => { const p = N.produkty.find(x => x.id === $("v_produkt").value); return p ? radekTabulky(p, $("v_hloubka").value) : null; };
function ksDleSpec(){ const r = specRadek(); if(r && $("v_ks")) $("v_ks").value = String(r.ks).replace(".", ","); }
const ksVlastni = () => { const x = num($("v_ks")?.value); return Number.isFinite(x) && x > 0 ? x : null; };

function naplnProdukty(chci){
  const h = $("v_hloubka").value;
  const dostupne = N.produkty.filter(p => radekTabulky(p, h));
  const sel = $("v_produkt");
  sel.innerHTML = N.produkty.map(p => {
    const r = radekTabulky(p, h);
    return `<option value="${p.id}" ${r?"":"disabled"}>${p.nazev}${r?"":" - pro tuto hloubku není"}</option>`;
  }).join("");
  const cil = dostupne.find(p => p.id === chci) || dostupne[0];
  if(cil) sel.value = cil.id;
}

/* volba ceny podle velikosti nákupu */
const stupne = p => (p.nakup && p.nakup.length) ? p.nakup : [{ks:null, cena:p.hodnoty[(N.baleni||{}).klicCeny||"cena"]}];
const popisStupne = t => `Při nákupu ${t.ks ? fmt(t.ks)+" "+N.kus : "po kusech"} - ${Number.isFinite(hodnota(t.cena)) ? fmt(t.cena)+" Kč/"+N.kus : "cenu doplníme"}`;
function naplnCeny(nejlepsi){
  const sel = $("v_cena"); if(!sel) return;
  const prod = N.produkty.find(p => p.id === $("v_produkt").value); if(!prod) return;
  const bylo = sel.value;
  sel.innerHTML = stupne(prod).map((t,i) => `<option value="${i}" ${Number.isFinite(hodnota(t.cena))?"":"disabled"}>${popisStupne(t)}</option>`).join("");
  const t = stupne(prod)[bylo];
  if(!nejlepsi && t && Number.isFinite(hodnota(t.cena))){ sel.value = bylo; return; }
  /* výchozí = první stupeň s cenou (nejmenší nákup, základní cena - odpovídá "od 300 Kč/m²" na webu) */
  const prvni = stupne(prod).findIndex(x => Number.isFinite(hodnota(x.cena)));
  sel.value = String(Math.max(prvni, 0));
}
const roky = n => !Number.isFinite(n) ? "" : n === 1 ? "1 rok" : (n >= 2 && n <= 4 && Number.isInteger(n)) ? `${fmt(n)} roky` : `${fmt(n,Number.isInteger(n)?0:1)} let`;
const nazevVase = () => ($("z_nazev")?.value || "").trim() || "Vaše LED";
const zvolenyStupen = () => { const v = $("v_cena")?.value; return v === undefined ? 0 : Number(v); };

function rozdil(nase, vase, lepsi){
  if(!Number.isFinite(nase) || !Number.isFinite(vase) || vase === 0) return {txt:"-", cls:"nula", lepsiNase:null};
  const pct = (nase - vase) / Math.abs(vase) * 100;
  if(Math.abs(pct) < 0.5) return {txt:"stejné", cls:"nula", lepsiNase:null};
  const lepsiNase = lepsi === "nizsi" ? nase < vase : nase > vase;
  return {txt:`${pct > 0 ? "+" : "−"}${fmt(Math.abs(pct),0)} %`, cls: lepsiNase ? "plus" : "minus", lepsiNase};
}

/* hodnoty na 1 m² pro produkt při zvolené hloubce */
function cenyProduktu(p, stupen){
  const h = { ...p.hodnoty }, t = stupne(p)[stupen || 0];
  if(N.baleni && t && Number.isFinite(hodnota(t.cena))) h[N.baleni.klicCeny] = t.cena;
  else if(N.baleni && stupen) h[N.baleni.klicCeny] = null;
  return h;
}
function naM2(p, h, baleni){
  const r = radekTabulky(p, h); if(!r) return null;
  const ks = ksVlastni() ?? r.ks;
  const o = { ks, poznamka: r.poznamka }, hod = cenyProduktu(p, baleni);
  N.parametry.forEach(par => o[par.klic] = hodnota(hod[par.klic]) * ks);
  return o;
}

function spocitej(){ spocitejVysledky(S); }
/* při změně zadání jen karta naší nabídky - výsledky až po kliknutí na KALKULACE */
function aktualizuj(){ spocitejVysledky(S, false); }


/* ===== KALKULACE - ukáže výsledek a zapíše výpočet ===== */
const navsteva = (crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2)).slice(0, 8);
let posledniZapis = "";
function oznacZmenu(){
  if($("vysledky").hidden) return;
  $("vysledky").classList.add("zastarale");
  $("kalkHlaska").textContent = "Údaje se změnily - klikněte na KALKULACE.";
  $("kalkHlaska").classList.add("zmena");
}
["input","change"].forEach(t => { koren.querySelector(".vstupy").addEventListener(t, oznacZmenu); koren.querySelector("#poleRozmer").addEventListener(t, oznacZmenu); });
$("kalkTlacitko").addEventListener("click", () => {
  spocitej();
  const v = S.posledniVysledek;
  if(!v || !Number.isFinite(v.vysledek.vaseCenaM2)){
    $("kalkHlaska").textContent = "Doplňte počet kusů, cenu, světlo a příkon vašich LED.";
    $("kalkHlaska").classList.add("zmena");
    return;
  }
  if(!Number.isFinite(v.vysledek.plocha) || v.vysledek.plocha <= 0){
    $("kalkHlaska").textContent = "Zadejte kladnou šířku, výšku a celý počet rámů.";
    $("kalkHlaska").classList.add("zmena");
    return;
  }
  const vys = $("vysledky"), prvni = vys.hidden;
  vys.hidden = false; vys.classList.remove("zastarale");
  $("kalkHlaska").textContent = "Hotovo. Když změníte údaje, klikněte znovu.";
  $("kalkHlaska").classList.remove("zmena");
  if(prvni) koren.querySelector(".verdikt").scrollIntoView({behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start"});
  const klic = JSON.stringify(v);
  const od = N.odeslani || {};
  if(klic === posledniZapis || !od.aktivni || !od.url) return;
  posledniZapis = klic;
  fetch(od.url, { method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: JSON.stringify({ ...v, typ: "kalkulace", navsteva, web: $("f_web").value, stranka: location.href }) }).catch(() => {});
});

$("formPoslat").addEventListener("submit", async e => {
  e.preventDefault();
  const hl = $("f_hlaska"), tl = $("f_tlacitko"), email = $("f_email").value.trim();
  const ukaz = (t, cls) => { hl.textContent = t; hl.className = "f-hlaska " + (cls||""); };
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ ukaz("Zadejte prosím platný e-mail, třeba jmeno@firma.cz.", "chyba"); $("f_email").focus(); return; }
  /* změněné údaje bez kliknutí na KALKULACE - nejdřív přepočítat, ať odejde to, co zákazník zadal */
  if($("vysledky").classList.contains("zastarale")) $("kalkTlacitko").click();
  const v = S.posledniVysledek;
  if(!v || !Number.isFinite(v.vysledek.vaseCenaM2)){ ukaz("Nejdřív vyplňte nahoře čísla vašich LED.", "chyba"); return; }
  const data = { ...v, email, souhlas: $("f_souhlas").checked, navsteva, web: $("f_web").value, stranka: location.href };
  const od = N.odeslani || {};
  if(!od.aktivni || !od.url){ ukaz(`Ukázka: na webu by teď výsledek odešel na ${email}${data.souhlas ? " i se souhlasem s nabídkami" : ""}. Tady se neodesílá.`, "ok"); return; }
  tl.disabled = true; ukaz("Odesílám…");
  try{
    const r = await fetch(od.url, { method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: JSON.stringify(data) });
    const j = await r.json();
    if(j.ok) ukaz(`Odesláno. Výsledek vám přijde na ${email} během pár minut.`, "ok");
    else ukaz(j.chyba === "Neplatný e-mail" ? "E-mail vypadá neplatně, zkontrolujte ho prosím." : "Odeslání se nepovedlo. Zkuste to prosím znovu, nebo napište na info@lightwell.cz.", "chyba");
  }catch(err){ ukaz("Odeslání se nepovedlo - zkontrolujte připojení a zkuste to znovu, nebo napište na info@lightwell.cz.", "chyba"); }
  finally{ tl.disabled = false; }
});

const S = { koren, N, $, fmt, num, hodnota, nazevVase, naM2, cenyProduktu, zvolenyStupen, roky, stupne, specRadek, ksVlastni, ksDleSpec, rozdil, oznacZmenu, posledniVysledek: null };

postav();

}
